<div class="header">
    <img src="https://fodimi.pl/img/site_logo/logo_4.png">
</div>

<div class="content-container">
    <img src="assets/img/done.svg" width="100">
    <h4 class="mb-4 mt-4">Dziękujemy za wypełnienie formularza! Wkrótce skontaktujemy się z Tobą aby przedstawić naszą ofertę</h4>
    <div class="text-center">
        <a  href="https://fodimi.pl"><button class="btn btn-primary">Wróć na stronę główną</button></a>
    </div>
</div>
